import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['question'];

  update() {
    this.questionTargets.forEach((question) => {
      const { dependsOn, expected, fieldPrefix } = question.dataset;
      const visible = JSON.parse(expected).map(String).includes(this.currentValue(dependsOn, fieldPrefix));
      question.classList.toggle('d-none', !visible);
    });
  }

  currentValue(key, prefix = 'answers') {
    const fields = Array.from(this.element.querySelectorAll(`[name="${prefix}[${key}]"]`));
    const field = fields.find((el) => el.type !== 'radio' || el.checked);
    return field ? field.value : '';
  }
}
